

























































































import {Component, Vue, Prop, Watch} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import {listMixin} from "@/mixins/listMixin";
import {GetContentList} from "@/request/common";

@Component({})
export default class Name extends mixins(listMixin) {
  @Prop()
  private startTime: any;
  @Prop()
  private endTime: any;
  @Prop()
  private selectedIds: any = [];
  @Prop()
  private replace: boolean = false;
  @Prop()
  private visible: boolean | undefined;

  @Watch("visible", {immediate: true})
  private visibleChange() {
    this.ifShow = this.visible;
    if (this.visible) {
      this.multipleSelection = [];
      this.search();
    }
  }

  private ifShow: any = false;
  private ifShowFengmian: any = true;
  private data: any = [];

  private get patient() {
    return this.$store.state.patient;
  }

  private get href() {
    return window.location.href;
  }

  private cancel() {
    this.$emit("cancel");
  }

  private goPrint() {
    if (this.multipleSelection.length == 0) {
      this.$message.warning("请选择需要打印的量表");
      return;
    }
    this.cancel();
    // let ids: any = [];
    // this.multipleSelection.forEach((ele: any) => {
    //   ids.push(ele.id);
    // });

    const orderMap: Record<string, number> = {
      '舌诊采集': 1,
      '舌下脉络采集': 2,
      '面诊采集': 3,
      '脉诊采集': 4, // 如果实际是“脉象采集”就改这里
      '问诊': 5,
      '中医体质辨识量表(2025版)': 9999, // 固定最后
    };

    const ids = this.multipleSelection
        .slice()
        .sort((a: any, b: any) => {
          const nameA = a.template?.name || '';
          const nameB = b.template?.name || '';

          const getOrder = (name: string) => {
            if (orderMap[name] !== undefined) return orderMap[name];
            return 999; // 其他量表排在问诊后、中医体质量表前
          };

          const orderA = getOrder(nameA);
          const orderB = getOrder(nameB);
          if (orderA !== orderB) {
            return orderA - orderB;
          }
          // 其他量表内部按名称排序
          return nameA.localeCompare(nameB, 'zh-CN');
        })
        .map((item: any) => item.id);

    // const url: any = this.href.split("/#/")[0];
    // window.open(
    //   url + "/#/main/report/ceping-report?ids=" + JSON.stringify(ids)
    // );
    if (this.replace) {
      this.$router.replace({
        path: "/main/report/ceping-report",
        query: {
          ids: JSON.stringify(ids),
          ifShowFengmian: this.ifShowFengmian ? "是" : "否",
        },
      });
    } else {
      this.$router.push({
        path: "/main/report/ceping-report",
        query: {
          ids: JSON.stringify(ids),
          ifShowFengmian: this.ifShowFengmian ? "是" : "否",
        },
      });
    }
  }

  /**
   * @description 获取列表
   */
  getList() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        page: this.filters.current_page,
        patient_id: this.patient.id,
        limit: 200,
        has_related_type: true,
        has_report_type: true,
      },
    };

    GetContentList(this, params, loading).then((res: any) => {

      let rawData = res.data;
      if (this.startTime && this.endTime) {
        const start = new Date(this.startTime);
        const end = new Date(this.endTime);

        this.data = rawData.filter((item: any) => {
          if (!item.create_datetime) return false;
          const createTime = new Date(item.create_datetime);
          return createTime >= start && createTime <= end;
        });
      } else {
        this.data = res.data;
      }

      this.filters.total_count = res.total;
      if (this.data.length > 0) {
        this.ifShowEmpty = false;
      } else {
        this.ifShowEmpty = true;
      }
      // 在数据加载完成后，如果selectedIds有值，需要默认选上
      // if (this.selectedIds && this.selectedIds.length > 0) {
      //   console.log('selectedIds:', this.selectedIds);
      //   console.log('data:', this.data);
      //
      //   // 直接设置选中列表，让表格自动更新
      //   this.multipleSelection = this.data.filter((item: any) => {
      //     const isSelected = this.selectedIds.includes(item.id);
      //     console.log('item.id:', item.id, 'isSelected:', isSelected);
      //     return isSelected;
      //   });

      // 强制更新表格的选中状态
      this.$nextTick(() => {
        const table = this.$refs.dataTable as any;
        if (table && table.toggleRowSelection) {
          // 先清空所有选中状态
          this.data.forEach((item: any) => {
            table.toggleRowSelection(item, false);
          });
          // 再设置需要选中的项
          this.data.forEach((item: any) => {
            table.toggleRowSelection(item, true);
          });
        }
      });
      // }
    });
  }
}
